// Programming languages' icons
import { SiC, SiGo, SiCsharp, SiPython, SiTypescript, SiJavascript, SiHtml5 } from 'react-icons/si'
import { FaJava } from "react-icons/fa";
// Command Line icons
import { SiPowershell, SiShell } from 'react-icons/si'
// Cloud Provider icons
import { SiMicrosoftazure, SiAmazonaws, SiGooglecloud } from 'react-icons/si'
// Databases' icons
import { SiMicrosoftsqlserver, SiPostgresql, SiMongodb } from 'react-icons/si'
// Big Data icons
import { SiDatabricks, SiApachespark } from 'react-icons/si';

export const skillset = [{ name: 'Java', icon: FaJava }, { name: 'C', icon: SiC }, { name: 'C#', icon: SiCsharp }, { name: 'GO', icon: SiGo }, { name: 'JavaScript', icon: SiJavascript }, { name: 'TypeScript', icon: SiTypescript }, { name: 'HTML', icon: SiHtml5 }, { name: 'Python', icon: SiPython },];

export const databaseSkills = [{ name: 'Microsoft SQL Server', icon: SiMicrosoftsqlserver }, { name: 'PostgreSQL', icon: SiPostgresql }, { name: 'MongoDB', icon: SiMongodb },]

export const commandLine = [{ name: 'PowerShell', icon: SiPowershell }, { name: 'Shell', icon: SiShell },];

export const cloudProviders = [{ name: 'Azure', icon: SiMicrosoftazure }, { name: 'AWS', icon: SiAmazonaws }, { name: 'Google Cloud', icon: SiGooglecloud },]

export const bigDataSkills = [
    { name: 'Databricks', icon: SiDatabricks },
    { name: 'Apache Spark', icon: SiApachespark },
]